var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('el-empty',{attrs:{"image":_vm.emptyImage,"description":_vm.$t('noData')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }